export default __webpack_public_path__ + "280218a84a470059624eb652cf77c688.png";